import { mapState } from 'vuex'
import Vue from 'vue'
import validation from './validation'
import appliesFilters from './applies-filters'

Vue.mixin({
  computed: {
    ...mapState('app', {
      $loading: 'loading'
    }),

    ...mapState('auth', {
      $user: 'user'
    })
  },

  methods: {
    $serverRoute (route) {
      return `${process.env.VUE_APP_API_URL}${route}`
    }
  }
})

export {
  appliesFilters,
  validation
}
